import React, { useEffect, useState } from "react";
import Swatches from "../../common/Swatches.js";

export default function ProductColorPicker({
  swatchesData,
  hexCodeArray,
  selectedColor, // optional prop
  setSelectedColor, // optional prop
  stickyProductBox,
  isStickySwatchesOpen,
  showStickySwatches,
  variantsData,
  showLastOne,
  fastShippingData,
  ...props
}) {
  // const swatchesData = [
  //   "red",
  //   "blue",
  //   "green",
  //   "yellow",
  //   "pink",
  //   "http://codeskulptor-assets.commondatastorage.googleapis.com/assets_clock_background.png",
  // ];
  return (
    <>
      <div>
        <Swatches
          data={swatchesData}
          hexCodeArray={hexCodeArray}
          selected={selectedColor}
          setSelected={setSelectedColor}
          stickyProductBox={stickyProductBox}
          isStickySwatchesOpen={isStickySwatchesOpen}
          showStickySwatches={showStickySwatches}
          ArrowDown="images/Icons/Chevron/large.svg"
          type="color"
          id="colorPicker"
          variantsData={variantsData}
          showLastOne={showLastOne}
          fastShippingColors={fastShippingData}
          category={props.category}
          colorMapping={props.colorMapping}
          highlightColor={props.highlightColor}
          onlyPDPColor={props.onlyPDPColor}
          soldOutOptions={props.soldOutOptions}
          linkedProductsArray={props.linkedProductsArray}
          categoryLvl1 = {props.categoryLvl1}
        />
      </div>
    </>
  );
}
